import React, { useRef } from "react";
import { Space, Empty, Collapse, Typography } from "antd";
import DocumentModal from "./DocumentModal";
import { FileOutlined } from "@ant-design/icons";

const DocumentCard = ({ data = [] }) => {
  const modalRef = useRef(null);
  return (
    <>
      <Collapse
        accordion
        defaultActiveKey={["1"]}
        items={[
          {
            key: "1",
            label: <Typography.Text strong>Tài liệu đại hội</Typography.Text>,
            children: (
              <>
                {data.length > 0 ? (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    {data?.map((x) => (
                      <Typography.Link
                        icon={<FileOutlined />}
                        onClick={() => modalRef.current.open(x)}
                        key={x.id}
                        size="large"
                        style={{ fontSize: 16 }}
                      >
                        {x.name}
                      </Typography.Link>
                    ))}
                  </Space>
                ) : (
                  <Empty description="Không tìm thấy thông tin" />
                )}
              </>
            ),
          },
        ]}
      />
      <DocumentModal ref={modalRef} />
    </>
  );
};

export default DocumentCard;
